<template>
    <div class="customer-registrations" v-loading="loading">
        <el-menu mode="horizontal" class="flex items-center px-30 h-60">
            <div class="date-picker-right">
                <v-custom-date-range-picker
                    @dateRange="
                        (v) => {
                            dateRange = v;
                        }
                    "
                ></v-custom-date-range-picker>
            </div>
        </el-menu>

        <div class="p-30">
            <el-row :gutter="20" class="mb-50">
                <!-- Total count -->
                <el-col :sm="24" :md="8">
                    <h3 class="mb-10">Customer Registrations</h3>
                    <el-card shadow="none">
                        <div class="text-center">
                            <div class="text-big">{{ statisticsData.customer_registrations_count || 0 }}</div>
                            <div>New customers in selected period</div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import api from '../libs/api';
import moment from 'moment';

export default {
    name: 'customer-registrations',
    props: ['config', 'rootConfig'],

    data() {
        return {
            statisticsData: {},
            loading: false,
            dateRange: [],
        };
    },

    watch: {
        dateRange() {
            if (this.dateRange && this.dateRange.length === 2) {
                this.loadStatistics();
            }
        },
    },

    methods: {
        loadStatistics() {
            this.loading = true;
            const startDate = moment(this.dateRange[0]).toISOString(true);
            const endDate = moment(this.dateRange[1]).toISOString(true);

            const apiResource = this.$resource(
                this.rootConfig.endPoint + '/reports/get_customer_registrations_count',
                {},
                {},
                {
                    headers: this.rootConfig.headers,
                    params: { start_date: startDate, end_date: endDate },
                }
            );

            apiResource
                .get()
                .then((res) => {
                    this.statisticsData = res.body;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    api.errorHandler;
                });
        },
    },
};
</script>

<style scoped>
.h-60 {
    height: 60px;
}

.p-30 {
    padding: 30px;
}

.px-30 {
    padding-left: 30px;
    padding-right: 30px;
}

.mb-10 {
    margin-bottom: 10px;
}

.mb-50 {
    margin-bottom: 50px;
}

.text-big {
    font-size: 48px;
    font-weight: bold;
    color: #09b3af;
    line-height: 1.2;
}

.text-gray {
    color: #aaa;
}

.text-center {
    text-align: center;
}

.title {
    margin: 0;
    padding-right: 30px;
}

.flex {
    display: flex;
    align-items: center;
}

.date-picker-right {
    margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// CustomerRegistrations.vue?7d29fa62